import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import profileService from "./profileService";

const safeParse = (value) => {
  try {
    if (!value || value === "undefined") return null;
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const getErrorText = (error) => {
  const data = error?.response?.data;
  if (data?.errors) return Object.values(data.errors)[0]?.[0];
  return data?.message || "Something went wrong";
};

// adminInfo ma merge karine save kare (token jalvai rahe)
const saveToSession = (data) => {
  const old = safeParse(sessionStorage.getItem("adminInfo")) || {};
  const merged = { ...old, ...data };
  sessionStorage.setItem("adminInfo", JSON.stringify(merged));
  return merged;
};

/* ---------- GET PROFILE ---------- */
export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async (_, thunkAPI) => {
    try {
      const res = await profileService.getProfile();
      if (res.status !== true) return thunkAPI.rejectWithValue(res.message);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorText(error));
    }
  }
);

/* ---------- UPDATE PROFILE (FormData) ---------- */
export const updateProfile = createAsyncThunk(
  "profile/updateProfile",
  async (formData, thunkAPI) => {
    try {
      const res = await profileService.updateProfile(formData);
      if (res.status !== true) return thunkAPI.rejectWithValue(res.message);
      return { data: res.data, message: res.message };
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorText(error));
    }
  }
);

/* ---------- CHANGE PASSWORD ---------- */
export const changePassword = createAsyncThunk(
  "profile/changePassword",
  async (payload, thunkAPI) => {
    try {
      const res = await profileService.changePassword(payload);
      if (res.status !== true) return thunkAPI.rejectWithValue(res.message);
      return res.message;
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorText(error));
    }
  }
);

const initialState = {
  // browser (sessionStorage) mathi turant data, pachi API thi refresh
  profile: safeParse(sessionStorage.getItem("adminInfo")) || {},
  isLoading: false, // page load
  isSaving: false,  // update / password
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearProfile: (state) => {
      state.profile = {};
    },
  },
  extraReducers: (builder) => {
    builder
      /* fetch */
      .addCase(fetchProfile.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.profile = saveToSession(action.payload);
      })
      .addCase(fetchProfile.rejected, (state) => {
        state.isLoading = false;
      })

      /* update */
      .addCase(updateProfile.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.isSaving = false;
        state.profile = saveToSession(action.payload.data);
      })
      .addCase(updateProfile.rejected, (state) => {
        state.isSaving = false;
      })

      /* password */
      .addCase(changePassword.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.isSaving = false;
      })
      .addCase(changePassword.rejected, (state) => {
        state.isSaving = false;
      });
  },
});

export const { clearProfile } = profileSlice.actions;
export default profileSlice.reducer;